import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { commsManagerApiRef, CommsManagerClient } from './api';
import { rootRouteRef } from './routes';

export const commsManagerPlugin = createPlugin({
  id: 'comms-manager',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: commsManagerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new CommsManagerClient(discoveryApi, fetchApi),
    }),
  ],
});

export const CommsManagerPage = commsManagerPlugin.provide(
  createRoutableExtension({
    name: 'CommsManagerPage',
    component: () =>
      import('./pages/CommsManagerPage').then(m => m.CommsManagerPage),
    mountPoint: rootRouteRef,
  }),
);
